import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { Client } from "@interfaces";
import { SubdomainService } from "../rest/subdomain.service";

@Injectable({
    providedIn: "root",
})
export class FaviconService {
    private icon = "https://res.cloudinary.com/minirobot/image/upload/v0/voyse/assets/favicons/apple-touch-icon.png";
    constructor(
        private subdomain: SubdomainService,
        @Inject(DOCUMENT) private document
    ) {}

    public applyFavicon() {
        this.subdomain.getClient().subscribe((client: Client) => {
            if (client?.favicon?.public_id) {
                this.icon = `https://res.cloudinary.com/minirobot/image/upload/v0/${client.favicon.public_id}.png`;
            }

            const link = this.document.getElementById("favicon") as HTMLLinkElement;

            if (link) {
                link.setAttribute("href", this.icon);
            }
        });
    }
}
